import { DatePicker, Form, Input, Radio } from 'antd';
import { observer } from 'mobx-react-lite';

import { requiredRule } from 'app/common/form-helpers/features/rules';
import { AvailableTrainTypesSelect } from 'app/railways/domains/train-types/components/available-train-types-select/available-train-types-select';

export const TariffProfileFields = observer(() => {
  const dateType = Form.useWatch('dateType');
  const showDatePickers = dateType !== 'always';

  return (
    <>
      <Form.Item
        name="name"
        label="Название профиля тарифа"
        rules={[requiredRule()]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="trainType" label="Тип состава">
        <AvailableTrainTypesSelect />
      </Form.Item>

      <Form.Item name="dateType" label="Тип времени действия">
        <Radio.Group>
          <Radio value="always">Действует всегда</Radio>
          <Radio value="tripDate">По дате отправления рейса</Radio>
          <Radio value="payDate">По дате платежа</Radio>
        </Radio.Group>
      </Form.Item>

      {showDatePickers && (
        <>
          <Form.Item name="dateFrom" label="Начальная дата">
            <DatePicker
              format="HH:mm DD.MM.YYYY"
              style={{ width: '100%' }}
              showTime
            />
          </Form.Item>
          <Form.Item name="dateTo" label="Конечная дата">
            <DatePicker
              format="HH:mm DD.MM.YYYY"
              style={{ width: '100%' }}
              showTime
            />
          </Form.Item>
        </>
      )}
    </>
  );
});
